declare namespace $ {

	type $mol_avatar__id_giper_baza_status_1 = $mol_type_enforce<
		ReturnType< $giper_baza_status['master_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_avatar__id_giper_baza_status_2 = $mol_type_enforce<
		ReturnType< $giper_baza_status['master_link'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_link__uri_giper_baza_status_3 = $mol_type_enforce<
		ReturnType< $giper_baza_status['master_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_giper_baza_status_4 = $mol_type_enforce<
		ReturnType< $giper_baza_status['link_content'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__hint_giper_baza_status_5 = $mol_type_enforce<
		ReturnType< $giper_baza_status['message'] >
		,
		ReturnType< $mol_link['hint'] >
	>
	export class $giper_baza_status extends $mol_select {
		master_id( id: any): string
		Option_logo( id: any): $mol_avatar
		master_link( ): string
		Well( ): $mol_avatar
		Fail( ): $mol_icon_sync_off
		link_content( ): readonly(any)[]
		hint( ): string
		message( ): ReturnType< $giper_baza_status['hint'] >
		Link( ): $mol_link
		minimal_width( ): number
		minimal_height( ): number
		Filter( ): any
		option_content( id: any): readonly(any)[]
		trigger_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=status.view.tree.d.ts.map